
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Input',
  props: {
    modelValue: {
      type: String
    },
    id: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: '',
      required: true
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'global'
    ])
  },
  emits: ['update:modelValue', 'focus', 'blur'],
  methods: {
    onLabelClick (label: any) {
      label.srcElement.previousElementSibling.focus();
    }
  }
});
